import { useMemo } from "react";
import { useQuery, useQueryClient } from "react-query";
import { referenceDataQueryKeys } from "../features/flightSchedule/ScheduleDraft/hooks/queryKeys";
import { scheduleDraftReferenceDataService } from "../features/flightSchedule/ScheduleDraft/services/scheduleDraftReferenceDataService";

const REFERENCE_STALE_TIME = 10 * 60 * 1000;
const REFERENCE_CACHE_TIME = 30 * 60 * 1000;

function getErrorMessage(error, fallback) {
    const detail = error?.response?.data?.detail;
    if (Array.isArray(detail) && detail.length > 0) {
        return detail[0]?.msg || fallback;
    }
    if (typeof detail === "string") {
        return detail;
    }
    return error?.message || fallback;
}

export const useAirports = (options = {}) => {
    const queryClient = useQueryClient();
    const query = useQuery(referenceDataQueryKeys.airports(), () => scheduleDraftReferenceDataService.getAirports(), {
        staleTime: REFERENCE_STALE_TIME,
        cacheTime: REFERENCE_CACHE_TIME,
        refetchOnWindowFocus: false,
        ...options,
    });

    const airportsList = query.data || [];
    const airportsMap = useMemo(
        () =>
            airportsList.reduce((acc, airport) => {
                const code = airport.iata_code || airport.code || airport.airport_code;
                if (code) {
                    acc[code] = airport;
                }
                return acc;
            }, {}),
        [airportsList],
    );

    return {
        airports: airportsMap,
        airportsMap,
        airportsList,
        loading: query.isLoading,
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        error: query.error ? getErrorMessage(query.error, "获取机场数据失败") : null,
        queryError: query.error,
        refreshAirports: () => queryClient.invalidateQueries(referenceDataQueryKeys.airports()),
        refetch: query.refetch,
    };
};

export default useAirports;
